import { render } from "./PsContentContainer.vue?vue&type=template&id=cd25205a&ts=true"
import script from "./PsContentContainer.vue?vue&type=script&lang=ts"
export * from "./PsContentContainer.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__